"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDatetime = _interopRequireDefault(require("react-datetime"));

var _moment = _interopRequireDefault(require("moment"));

var _classnames = _interopRequireDefault(require("classnames"));

var _excluded = ["dropup", "alignRight", "onChange", "className"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var isValidDate = function isValidDate(date) {
  return (0, _typeof2.default)(date) === 'object';
};

var DatePicker = function DatePicker(props, ref) {
  var dropup = props.dropup,
      alignRight = props.alignRight,
      onChange = props.onChange,
      className = props.className,
      remainingProp = (0, _objectWithoutProperties2.default)(props, _excluded);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      hasError = _useState2[0],
      setHasError = _useState2[1];

  var handleChange = function handleChange(date) {
    var isValid = isValidDate(date);
    setHasError(!isValid);
    onChange(date, isValid);
  };

  var classes = (0, _classnames.default)('DatePicker', hasError && 'has-error', dropup && 'dropup', alignRight && 'align-right', className && className);
  return /*#__PURE__*/_react.default.createElement(_reactDatetime.default, (0, _extends2.default)({}, remainingProp, {
    onChange: handleChange,
    className: classes
  }));
};

DatePicker.defaultProps = {
  closeOnSelect: true,
  dropup: false,
  defaultValue: (0, _moment.default)(),
  locale: 'en-GB',
  onChange: function onChange() {},
  clearableInput: false,
  minWidth: 0
};
DatePicker.propTypes = {
  className: _propTypes.default.string,
  closeOnSelect: _propTypes.default.bool,
  clearableInput: _propTypes.default.bool,
  defaultValue: _propTypes.default.object,
  locale: _propTypes.default.string,
  onChange: _propTypes.default.func,
  dropup: _propTypes.default.bool,
  minWidth: _propTypes.default.number,
  alignRight: _propTypes.default.bool
};
var _default = DatePicker;
exports.default = _default;